import { render, staticRenderFns } from "./newRetailAccount.vue?vue&type=template&id=2d154f81"
import script from "./newRetailAccount.vue?vue&type=script&lang=js"
export * from "./newRetailAccount.vue?vue&type=script&lang=js"
import style0 from "./newRetailAccount.vue?vue&type=style&index=0&id=2d154f81&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports